/**
 * Takes a number and rounds it to the nearest thousand
 * @param n Number to round
 * @returns Number rounded to the nearest thousand (if applicable)
 */
const roundConstValue = 10000;
const roundConstValueForMath = 1000;
function round(n: number): number {
  if (n === 0) {
    return n;
  }
  if (Math.abs(n) < roundConstValue) {
    return n;
  }
  return Math.round(n / roundConstValueForMath) * roundConstValueForMath;
}

export default round;
